import React, {useEffect, useState} from 'react'
import Swal from 'sweetalert2'
import LeadForm from './leadForm'
import { createLeads ,getAssignee} from '../../../api'





const LeadModal = ({isOpen, onClose,onCreateLead}) => {
  const [formData, setFormData] = useState({
    type: '',
    name: '',
    email: '',
    country:'',
    phone: '',  
    created__by: '',
  })

  const [submittedForm, setSubmittedForm] = useState(false)
  const [loading, setLoading] = useState(false)
  const [assigneeList, setAssigneeList] = useState([]);


  useEffect(() => {
    const fetchAssignees = async () => {
      try {
        const assignees = await getAssignee();
        setAssigneeList(assignees);
      } catch (error) {
        console.error('Failed to fetch assignees:', error);
      }
    };

    fetchAssignees();
  }, []);

  const handleInputChange = (e) => {
    const {name, value} = e.target
    setFormData((prev) => ({...prev, [name]: value}))
  }

  const handleSelectChange = (field, value) => {
    setFormData((prevData) => ({
      ...prevData,
      [field]: value,
    }))
  }

  const validateForm = () => {
    if (!formData.name) {
      return 'Lead Name is required.';      
  }  
  if (!formData.email|| !/\S+@\S+\.\S+/.test(formData.email)) {
      return 'Valid Enterprise Email is required.';
  }   

   if(!formData.phone){
     return 'Phone number is required.'
   }
    return null
  }

  const handleSubmit = async () => {
    const errorMessage = validateForm();
    if (errorMessage) {
      Swal.fire({ icon: 'error', title: errorMessage });
      return;
    }
  
    setLoading(true);
  
    try {
      Swal.fire({
        title: 'Submitting...',
        text: 'Please wait.',
        allowOutsideClick: false,
        didOpen: () => Swal.showLoading(),
      });
  
      await createLeads(formData); // Replace with actual API call
  
      Swal.fire({
        icon: 'success',
        title: `Lead Created for ${formData.name}.`,
      }).then(() => {
        setSubmittedForm(true);
        onCreateLead(); // Call onCreateLead to fetch updated data
        resetData();
      });
    } catch (error) {
      Swal.fire({ icon: 'error', title: 'Failed to create lead.' });
    } finally {
      setLoading(false);
    }
  };
  

  const resetData = () => {
    setFormData({type: '', name: '', email: '', country:'', phone: '',  created__by: ''})
    onClose()
    setSubmittedForm(false)
  }

  return (
    <div
      className={`modal fade ${isOpen ? 'show' : ''}`}
      tabIndex={-1}
      style={{display: isOpen ? 'block' : 'none'}}
    >
      <div className='modal-dialog'>
        <div className='modal-content' style={{marginTop: '10rem'}}>
          <div className='modal-header'>
            <h3 className='modal-title'>
              {submittedForm ? 'Lead Created Successfully' : 'Create New Lead'}
            </h3>
            <button className='btn btn-icon btn-sm btn-active-secondary ms-2' onClick={resetData}>
            <i className="ki-solid ki-cross fs-2x"></i>
            </button>
          </div>
          <div className='modal-body' style={{height: '40vh', overflow: 'auto'}}>
            <LeadForm formData={formData} onInputChange={handleInputChange} onSelectChange={handleSelectChange} assigneeName={assigneeList} />
          </div>
          <div className='modal-footer'>
            {submittedForm ? (
              <button type='button' className='btn btn-secondary' onClick={resetData}>
                Close
              </button>
            ) : (
              <button
                type='button'
                className='btn'
                style={{backgroundColor: '#6D9300', color: 'white'}}
                onClick={handleSubmit}
                disabled={loading}
              >
                {loading ? 'Submitting...' : 'Save'}
              </button>
            )}
          </div>
        </div>
      </div>
    </div>
  )
}

export default LeadModal


